import { Component, OnInit, OnDestroy } from '@angular/core'
import { ActivatedRoute } from '@angular/router'
import { Subject } from 'rxjs'
import { takeUntil, filter, switchMap, tap } from 'rxjs/operators'

import { NavLink } from '@shared/components/layout/tab-nav-bar.component'
import { ClientsService } from '@app/modules/admin/clients/clients.service'
import { AuthService } from '@app/modules/auth/auth.service'
import { RoleType } from '@core/types/role.type'
import { PermissionsSource } from '@core/types/permissions.source'
import { User } from '@app/shared/models/user.model'

@Component({
  selector: 'lin-client-user-details',
  templateUrl: './client-user-details.component.html',
  standalone: false,
})
export class ClientUserDetailsComponent implements OnInit, OnDestroy {
  clientId: number

  private readonly onDestroy$ = new Subject<void>()

  constructor(
    private clientsService: ClientsService,
    private authService: AuthService,
    private route: ActivatedRoute,
  ) {}

  navLinks: NavLink[] = [
    {
      path: './profile-info',
      label: 'CLIENT.USERS.PROFILE_INFO',
    },
    // TODO: need to uncomment
    // {
    //   path: './access-info',
    //   label: 'CLIENT.USERS.ACCESS_INFO',
    // },
  ]

  ngOnInit() {
    const id = <string>this.route.snapshot.params.id
    this.authService.currentUser$
      .pipe(
        tap((user) => (this.clientId = user.team.clientId)),
        switchMap(() => this.clientsService.getClientUser(this.clientId, id)),
        filter((user) => user.role.name === RoleType.Driver || (user as User).isDualAccount),
        takeUntil(this.onDestroy$),
      )
      .subscribe(() => {
        const tab = {
          path: './documents',
          label: 'CLIENT.VEHICLES.DOCUMENTS_TITLE',
          permission: PermissionsSource['DRIVERS.DOCUMENTS_LIST'],
        }

        this.navLinks.push(tab)
      })
  }

  ngOnDestroy() {
    this.onDestroy$.next()
    this.onDestroy$.complete()
  }
}
